const updates = [
  {
    date: '2026.07.20',
    title: '海角网首页全新改版上线',
    desc: '全新设计的海角官网首页正式发布，优化了内容布局和导航体验，海角在线访问更加流畅。',
    tag: '平台公告',
  },
  {
    date: '2026.07.18',
    title: '海角视频创作者激励计划启动',
    desc: '海角社面向原创视频作者推出新一轮流量扶持和收益分成计划，助力优质内容生产。',
    tag: '创作者',
  },
  {
    date: '2026.07.15',
    title: '社区安全防护系统升级完成',
    desc: '海角社区网站全面升级安全防护机制，海角网址接入更加稳定可靠，用户数据安全保障再提升。',
    tag: '系统更新',
  },
  {
    date: '2026.07.12',
    title: '海角论坛新版块上线',
    desc: '新增「科技前沿」「文艺创作」两大讨论版块，海角论坛内容生态进一步丰富。',
    tag: '功能上新',
  },
  {
    date: '2026.07.08',
    title: '千万原创内容里程碑达成',
    desc: '海角网平台累计原创内容突破一千万，海角社区成员共同见证这一重要时刻。',
    tag: '里程碑',
  },
  {
    date: '2026.07.05',
    title: '移动端适配优化完成',
    desc: '海角网移动版全面升级，在手机端浏览海角视频和论坛的体验大幅提升。',
    tag: '体验优化',
  },
  {
    date: '2026.07.01',
    title: '海角社暑期主题活动上线',
    desc: '为期两个月的「夏日创作季」主题活动在海角社区启动，参与即可赢取专属奖励。',
    tag: '社区活动',
  },
  {
    date: '2026.06.28',
    title: '海角最新地址导航页更新',
    desc: '海角网址导航页新增快速入口和常用链接，帮助用户更高效地访问海角在线各功能区域。',
    tag: '服务优化',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            海角网运营动态与更新公告
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300/60 space-y-8">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap font-mono">{item.date}</span>
                  <div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="text-sm md:text-base font-medium text-foreground-900">
                        {item.title}
                      </h3>
                      <span className="inline-block px-2 py-0.5 rounded-full text-[10px] font-medium bg-secondary-100 text-secondary-700">
                        {item.tag}
                      </span>
                    </div>
                    <p className="mt-1 text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}